import { SET_FORM, SET_FORM_KEY } from './form.types'
import { keyValueAction } from '../../utils/redux'

export const setForm = (userInfo) => ({
  type: SET_FORM,
  payload: userInfo,
})

export const setFormKey = (key, value) => keyValueAction(SET_FORM_KEY, key, value)
